import { render } from "./AdminUsagePlans.vue?vue&type=template&id=f94112e2&scoped=true"
import script from "./AdminUsagePlans.vue?vue&type=script&lang=js"
export * from "./AdminUsagePlans.vue?vue&type=script&lang=js"

import "./AdminUsagePlans.vue?vue&type=style&index=0&id=f94112e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94112e2"]])

export default __exports__